import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const ProcoreIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Procore Icon</title>;
    t1 = <g><g><path fill="var(--color-default-foreground)" d="M286.8,646.5c-56.6,0-96.7-40-96.7-96.7v-290.1c0-56.7,40-96.7,96.7-96.7h306.6c56.6,0,96.7,40,96.7,96.7v96h-100.2l-60.1-104.3h-176.1l-89.1,153.3,89.1,153.3h176.1l60.1-104.3h100.2v96c0,56.6-40.1,96.7-96.7,96.7h-306.6Z" /><polygon fill="#ff5200" points="488.5 323.2 536.2 404.8 488.5 486.3 394.6 486.3 346.9 404.8 394.6 323.2 488.5 323.2" /></g></g>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="300 0 300 800" width="1em" height="1em" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};